import { render } from "./StampCorrectionPage.vue?vue&type=template&id=90e207b0"
import script from "./StampCorrectionPage.vue?vue&type=script&lang=js"
export * from "./StampCorrectionPage.vue?vue&type=script&lang=js"

import "./StampCorrectionPage.vue?vue&type=style&index=0&id=90e207b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__